import DashboardIncidentsMainOpenIncidents from './DashboardIncidentsMainOpenIncidents';

export default DashboardIncidentsMainOpenIncidents;
